<script>
  import BusinessCard from "./BusinessCard.vue";
  import { cloneDeep } from "lodash";
  export default {
    components: { BusinessCard },
    props: {
      businessList: {
        type: Array,
        required: false,
      },
      focusedLocation: {
        type: Object,
        required: false,
      },
      closureMessage: {
        type: String,
        required: true,
      },
      pendingOpeningMessage: {
        type: String,
        required: true,
      },
      isLocatorEmbeded: {
        type: Boolean,
        required: true,
      },
      businessCardShowcaseFlags: {
        type: Object,
        required: true,
      },
      businessCardShowDetailIcons: {
        required: true,
        type: Boolean,
      },
      iconLibrary: {
        required: true,
        type: String,
      },
    },
    data() {
      return {
        businessesMounted: 0,
        businessCardsMounted: false,
        businessListCopy: [],
      };
    },
    created() {
      this.businessListCopy = cloneDeep(this.businessList);
    },
    watch: {
      /**
       * @description Resets businessCardsMounted to false when the businessList data updates. This is
       * required in order for the updateDataLayerEvent to be dispatched when the new list of
       * businesses complete mounting.
       */
      businessList: {
        handler(newList) {
          this.businessCardsMounted = false;
          this.businessListCopy = cloneDeep(newList);
        },
      },
      businessListCopy() {
        // The Copy list generally updates when the order changes
        // When the order changes, scroll back to the top
        const sideBarContainer = document.querySelector(
          ".locator-sidebar__results-container__business-list",
        );
        if (sideBarContainer)
          sideBarContainer.scrollTo({ top: 0, behavior: "smooth" });
      },
      /**
       * @description Dispatches updateDataLayerEvent to attach GTM tagged elements with click handlers if
       * all of the businessCardsMounted is true meaning all are mounted.
       */
      businessCardsMounted: function (allMounted) {
        if (allMounted) {
          document.dispatchEvent(new Event("updateDataLayerEvent"));
        }
      },
    },

    methods: {
      handleCardSelection(location) {
        this.$emit("setFocusedLocation", location);
      },
      // Updates businessCardsMounted based off wheather  the business card business data is
      // the final business in the list of businesses.
      handleBusinessCardMount(business) {
        business?.url_name ==
        this?.businessListCopy[this.businessListCopy.length - 1]?.url_name
          ? (this.businessCardsMounted = true)
          : (this.businessCardsMounted = false);
      },
      locationIsSelected(business) {
        return (
          this.focusedLocation &&
          this.focusedLocation.url_name == business.url_name
        );
      },
      /**
       * @param  {Business} biz selected location object
       * @description  Updates the sroll postion to the top and reorders the businessList.
       */
      handleMarkerSelect(biz) {
        const idx = this.businessListCopy.findIndex(
          (b) => b.url_name === biz.url_name,
        );
        if (idx <= 0) return;
        const [target] = this.businessListCopy.splice(idx, 1);
        this.businessListCopy.unshift(target);
      },
    },
  };
</script>

<template>
  <transition-group name="flip-list">
    <business-card
      v-for="business in businessListCopy"
      :key="business.url_name"
      :isSelected="locationIsSelected(business)"
      :isLocatorEmbeded="isLocatorEmbeded"
      :business="business"
      :closureMessage="closureMessage"
      :pendingOpeningMessage="pendingOpeningMessage"
      :businessCardShowcaseFlags="businessCardShowcaseFlags"
      :businessCardShowDetailIcons="businessCardShowDetailIcons"
      :iconLibrary="iconLibrary"
      @businessCardClick="handleCardSelection(business)"
      @hook:mounted="handleBusinessCardMount(business)"
    ></business-card>
  </transition-group>
</template>

<style lang="scss" scoped>
  .flip-list-move {
    transition: transform 1s;
  }
</style>
